import React from 'react';
import PropTypes from 'prop-types';
import './OperatorProfileLink.css';

/*
 * An operator's name, where pressing it opens their profile.
 *
 * The chat screens and the conversation panel have had this for a while and the
 * statistics did not, which made the same name clickable in one place and inert
 * in another - the sort of difference nobody reports as a bug and everybody
 * stops trusting. This is that behaviour in one piece, so the next list to show
 * operators inherits it rather than reimplementing it.
 *
 * It wraps whatever is already drawn - an avatar beside a name, a name on its
 * own - instead of drawing it, because every list that shows an operator shows
 * them slightly differently and none of that is this component's business.
 *
 * Without the permission, or without an operator to open, it steps out of the
 * way entirely and leaves the markup exactly as it was: no button, no pointer,
 * nothing to press. A control that looks pressable and refuses is worse than no
 * control.
 */
const OperatorProfileLink = ({operator, canOpen, onOpen, className, children}) => {
    if (!canOpen || !operator || !operator.id || typeof onOpen !== 'function') {
        return <React.Fragment>{children}</React.Fragment>;
    }

    return (
        <button
            type="button"
            className={'operator-profile-link' + (className ? ' ' + className : '')}
            onClick={() => onOpen(operator)}
        >
            {children}
        </button>
    );
};

OperatorProfileLink.propTypes = {
    /* needs at least an id; the drawer reads the rest for its heading */
    operator: PropTypes.object,
    canOpen: PropTypes.bool,
    onOpen: PropTypes.func,
    className: PropTypes.string,
};

export default OperatorProfileLink;



// WEBPACK FOOTER //
// ./src/components-new/general/OperatorProfileLink.jsx